import { Injectable } from '@angular/core';
import { EnvService, UmamiConfig } from './env.service';

@Injectable({ providedIn: 'root' })
export class UmamiService {
  private initialized = false;
  private scriptRequested = false;

  constructor(private envService: EnvService) {}

  initialize(): void {
    if (this.initialized) return;
    this.initialized = true;

    this.envService.load().then((config) => {
      const umami = config.umami ?? null;
      if (!this.isEnabled(umami)) return;

      this.loadScript(umami);
    });
  }

  private loadScript(config: UmamiConfig): void {
    if (this.scriptRequested || document.getElementById('umami-analytics-script')) return;

    this.scriptRequested = true;

    const script = document.createElement('script');
    script.id = 'umami-analytics-script';
    script.defer = true;
    script.src = config.scriptUrl as string;
    script.setAttribute('data-website-id', config.websiteId as string);
    script.addEventListener('error', () => {
      this.scriptRequested = false;
      console.warn('Umami analytics failed to load.');
    });

    document.head.appendChild(script);
  }

  private isEnabled(config: UmamiConfig | null): config is UmamiConfig {
    return !!config?.enabled && !!config.scriptUrl && !!config.websiteId;
  }
}
